// @flow

import { all, put, takeEvery, call } from "redux-saga/effects";
import type { Action } from "redux-action";
import http from "@http";
import actionCreators from "@modules/service/actionCreator";
import {
  GetAppAdoptionDepartments,
  ExportAppAdoptionDepartments,
  GetAppAdoptionHighlights,
} from "@modules/service/constants/actions";

import type { SortingOptionsType } from "@modules/service/components/adoption-tab";
import { sendSuccessMessage } from "@modules/app/actionCreator";

export function* onGetAppAdoptionHighlights({
  payload,
}: Action<{ clientId: number }>): Generator<
  *,
  void,
  { data: { onboardedToApp: Object, downloads: [] } },
> {
  try {
    if (!payload || !payload.clientId) {
      throw Error(`Invalid payload provided:\n\n${JSON.stringify(payload, null, 2)}\n\n`);
    }
    const { clientId } = payload;

    const response = yield call(
      http.get,
      `/api/v1/service-admin/client/${clientId}/service-config/app-adoption/highlights`,
    );
    yield put(actionCreators.GetAppAdoptionHighlightsSuccess(response.data));
  } catch (e) {
    yield put(actionCreators.GetAppAdoptionHighlightsError(e?.response?.statusText));
  }
}

export function* onGetAppAdoptionDepartments({
  payload,
}: Action<{ clientId: number, sort: SortingOptionsType }>): Generator<
  *,
  void,
  { data: { onboardedToApp: Object, downloads: [] } },
> {
  try {
    if (!payload || !payload.clientId || !payload.sort) {
      throw Error(`Invalid payload provided:\n\n${JSON.stringify(payload, null, 2)}\n\n`);
    }
    const { clientId, sort } = payload;

    const response = yield call(
      http.get,
      `/api/v1/service-admin/client/${clientId}/service-config/app-adoption/departments?sort=${sort}`,
    );
    yield put(actionCreators.GetAppAdoptionDepartmentsSuccess(response.data));
  } catch (e) {
    yield put(actionCreators.GetAppAdoptionDepartmentsError(e.response));
  }
}
export function* onExportAppAdoptionDepartments({
  payload,
}: Action<{ clientId: number, sort: SortingOptionsType }>): Generator<
  *,
  void,
  { data: { onboardedToApp: Object, downloads: [] } },
> {
  try {
    if (!payload || !payload.clientId || !payload.sort) {
      throw Error(`Invalid payload provided:\n\n${JSON.stringify(payload, null, 2)}\n\n`);
    }
    const { clientId, sort } = payload;

    const response = yield call(
      http.get,
      `/api/v1/service-admin/client/${clientId}/service-config/app-adoption/departments/export?sort=${sort}`,
      {
        headers: {
          Accept: "text/csv",
        },
      },
    );
    yield put(actionCreators.ExportAppAdoptionDepartmentsSuccess(response.data));
  } catch (e) {
    yield put(actionCreators.ExportAppAdoptionDepartmentsError(e.response));
  }
}

export function* AppAdoptionSagas(): Generator<*, void, void> {
  yield all([
    takeEvery(GetAppAdoptionHighlights, onGetAppAdoptionHighlights),
    takeEvery(GetAppAdoptionDepartments, onGetAppAdoptionDepartments),
    takeEvery(ExportAppAdoptionDepartments, onExportAppAdoptionDepartments),
  ]);
}

export default AppAdoptionSagas;
